import { get } from 'lodash';

/* eslint-disable no-undef */
export default function sumDollarAmounts(data, propName) {
  if (!data || !data.length) {
    return 0;
  }

  // Convert each float dollar amount to cents and sum using BigInt to avoid precision loss
  const totalCents = data.reduce((acc, item) => {
    // Check if the property exists and is a valid number
    // eslint-disable-next-line no-restricted-globals
    if (get(item, propName) && !isNaN(get(item, propName))) {
      const amountInCents = BigInt(Math.round(get(item, propName) * 100)); // Convert dollars to cents
      return acc + amountInCents;
    }
    return acc; // If invalid, just return the current accumulator
  }, BigInt(0)); // Initial accumulator value as BigInt

  // Convert the total cents back to dollars by dividing by 100 and adjust to float
  const totalDollars = Number(totalCents) / 100;

  return totalDollars;
}

export function sumArray(amounts) {
  const amountObjects = amounts.map((amount) => ({ amount }));

  return sumDollarAmounts(amountObjects, 'amount');
}
